import userOrgProfileService from "@/services/bytepro/userOrgProfile.service";

export const userOrgProfileApi = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    // Fetches a list of UserOrgProfiles based on userId
    getUserOrgProfiles({ commit }, userId) {
      return userOrgProfileService.getUserOrgProfiles(userId).then(
        (resp) => {
          commit(
            "dummyConsole",
            "userOrgProfileService.getUserOrgProfiles - success"
          );
          return Promise.resolve(resp);
        },
        (error) => {
          commit(
            "dummyConsole",
            "userOrgProfileService.getUserOrgProfiles - error"
          );
          return Promise.reject(error);
        }
      );
    },

    // Fetches a single UserOrgProfile based on userId, organizationId, and securityProfileId
    getUserOrgProfile(
      { commit },
      { userId, organizationId, securityProfileId }
    ) {
      return userOrgProfileService
        .getUserOrgProfile(userId, organizationId, securityProfileId)
        .then(
          (resp) => {
            commit(
              "dummyConsole",
              "userOrgProfileService.getUserOrgProfile - success"
            );
            return Promise.resolve(resp);
          },
          (error) => {
            commit(
              "dummyConsole",
              "userOrgProfileService.getUserOrgProfile - error"
            );
            return Promise.reject(error);
          }
        );
    },

    // Creates a new UserOrgProfile entry
    createUserOrgProfile({ commit }, userOrgProfile) {
      return userOrgProfileService.createUserOrgProfile(userOrgProfile).then(
        (resp) => {
          commit(
            "dummyConsole",
            "userOrgProfileService.createUserOrgProfile - success"
          );
          return Promise.resolve(resp);
        },
        (error) => {
          commit(
            "dummyConsole",
            "userOrgProfileService.createUserOrgProfile - error"
          );
          return Promise.reject(error);
        }
      );
    },

    // Updates an existing UserOrgProfile entry based on userOrgProfileId
    updateUserOrgProfile(
      { commit },
      { userOrgProfileId, updatedUserOrgProfile }
    ) {
      return userOrgProfileService
        .updateUserOrgProfile(userOrgProfileId, updatedUserOrgProfile)
        .then(
          (resp) => {
            commit(
              "dummyConsole",
              "userOrgProfileService.updateUserOrgProfile - success"
            );
            return Promise.resolve(resp);
          },
          (error) => {
            commit(
              "dummyConsole",
              "userOrgProfileService.updateUserOrgProfile - error"
            );
            return Promise.reject(error);
          }
        );
    },

    // Deletes a UserOrgProfile entry based on userOrgProfileId
    deleteUserOrgProfile({ commit }, userOrgProfileId) {
      return userOrgProfileService.deleteUserOrgProfile(userOrgProfileId).then(
        (resp) => {
          commit(
            "dummyConsole",
            "userOrgProfileService.deleteUserOrgProfile - success"
          );
          return Promise.resolve(resp);
        },
        (error) => {
          commit(
            "dummyConsole",
            "userOrgProfileService.deleteUserOrgProfile - error"
          );
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {
    dummyConsole(state, obj) {
      console.log(obj);
    },
  },
};
